// extracted by mini-css-extract-plugin
export var active = "_fr-7";
export var blink = "_fr-8";
export var dropDownSelector = "_fr-4";
export var dropDownWrapper = "_fr-3";
export var fakeCursor = "_fr-6";
export var fontSizeButton = "_fr-9";
export var formQuillEditor = "_fr-0";
export var pressed = "_fr-a";
export var qlBlank = "_fr-1";
export var textFormattingToolbar = "_fr-2";
export var textToolbarOption = "_fr-5";